import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/_lib/analytics/analytics-scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/_providers/marketing-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/(marketing)/_lib/intercom-facade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/opt/build/repo/context/i18n.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"app/_lib/marketing-document.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"display\":\"swap\",\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"sans\"}");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/styles/globals.css");
